import * as React from "react";
import classnames from "classnames";
import { Util, ConnectedFormSelect } from "@grandvisionhq/forms";
const SelectReason = ({ className, options, ...rest }) => {
  const formattedOptions = Util.createSelectOptions(options, "label");
  return /* @__PURE__ */ React.createElement(
    ConnectedFormSelect,
    {
      initialState: void 0,
      required: true,
      className: classnames("return-item__select", className),
      options: formattedOptions,
      ...rest
    }
  );
};
export {
  SelectReason
};
//# sourceMappingURL=SelectReason.js.map
